import { render, staticRenderFns } from "./du.vue?vue&type=template&id=34da14d5"
import script from "./du.vue?vue&type=script&lang=js"
export * from "./du.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports